<template>
	<div>
		<titles titlename="部门管理" titlecontent="这里可以管理部门" :mbx="paths"></titles>
		<manges :pagesobj="pagesobj" :tabtitlelist="tabtitlelsit" :mangesname="mangesname" :tablist="tablist"></manges>
	</div>
</template>

<script>
	import titles from "@/components/title/title.vue"
	import manges from "@/components/mangeslist/manges.vue"
	// import {
		
	// } from "@/request/api/mange/mange.js"

	export default {
		data() {
			return {
				mangesname: {
					name: "部门",
					topcolor: "#AB26AA",
					contentcolor: "#22AF47",
					show:false
				},
				pagesobj:{
					pageIndex:1,
					pageSize:10,
					pro_name:"",
					maxpages:null
				},
				tabtitlelsit: [{
						label: "部门名称",
						prop: "name",
					},
					{
						label: "所属上级部门",
						prop: "sssjiculb",
					},
					{
						label: "所属院校",
						prop: "sshool",
					},
					{
						label: "描述",
						prop: "msconten",
					}
				],

				tablist: [{
					name: "教务处",
					sssjiculb: "无",
					sshool: "柳州铁道职业技术学院",
					msconten:"部门文字描述",
					usersid: 1
				}, {
					name: "科研处",
					sssjiculb: "无",
					sshool: "柳州铁道职业技术学院",
					msconten:"部门文字描述",
					usersid: 2
				}, {
					name: "财政处",
					sssjiculb: "无",
					sshool: "柳州铁道职业技术学院",
					msconten:"部门文字描述",
					usersid: 3
				}],


				// 标题组件
				paths: [{
					path: "/qitamanage/clubmanage",
					name: "部门管理"
				}]
			}
		},
		methods: {

		},
		components: {
			titles,
			manges
		}

	}
</script>

<style lang="less">
	/deep/ .el-dialog__header {
		padding: 14px 19px 10px;
		background: #05A34A;
		color: #fff;
		font-size: 1.2rem;
	
		.el-dialog__headerbtn .el-dialog__close {
			color: #fff;
			font-size: 1.4rem;
	
		}
	
		.dialog-header-title {
			span {
				margin-left: 0.6rem;
			}
		}
	}
</style>